import React from 'react'
import { Globe } from 'lucide-react'
import { useCurrency } from '../contexts/CurrencyContext'
import { clsx } from 'clsx'

export default function CurrencySelector({ className = '', dark = false }) {
  const { baseCurrency, selectedCurrency, currencyInfo } = useCurrency()
  const activeCode = selectedCurrency || baseCurrency || 'INR'
  const info = currencyInfo || { symbol: '₹', name: 'Indian Rupee', code: 'INR' }

  return (
    <div
      className={clsx(
        "flex items-center space-x-1.5 px-2.5 py-1 text-xs font-medium rounded-lg border select-none transition-colors",
        dark
          ? "bg-slate-800/90 text-slate-200 border-slate-700"
          : "bg-white text-gray-700 border-gray-300",
        className
      )}
      title={`Default Base Currency configured in System Settings: ${info.name || activeCode} (${activeCode})`}
    >
      <Globe className={clsx("w-3.5 h-3.5 shrink-0", dark ? "text-blue-400" : "text-gray-500")} />
      <span className={clsx("text-[10px] font-bold uppercase tracking-wider hidden sm:inline", dark ? "text-slate-400" : "text-gray-400")}>
        Currency:
      </span>
      <span className="font-mono font-bold text-slate-100">{info.symbol}</span>
      <span className="font-bold text-slate-100">{activeCode}</span>
    </div>
  )
}